import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  communicationList: [],
  loading: false,
  error: null,
};

const communicationSlice = createSlice({
  name: "communication",
  initialState,
  reducers: {
    fetchCommunicationListRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCommunicationListSuccess: (state, action) => {
      state.communicationList = action.payload;
      state.loading = false;
    },
    fetchCommunicationListError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    updateCommunicationRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateCommunicationSuccess: (state, action) => {
      state.communicationList = action.payload.state;
      state.loading = false;
    },
    updateCommunicationError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  fetchCommunicationListRequest,
  fetchCommunicationListSuccess,
  fetchCommunicationListError,
  updateCommunicationRequest,
  updateCommunicationSuccess,
  updateCommunicationError,
} = communicationSlice.actions;

export default communicationSlice.reducer;
